// import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
// import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
// import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";
import nine from "../assets/svg/projects/nine.svg";
// import ten from "../assets/svg/projects/ten.svg";
// import eleven from "../assets/svg/projects/eleven.svg";
// import twelve from "../assets/svg/projects/twelve.svg";
import ewf from "../assets/svg/projects/ewf.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "Ethiopian wushu Federation",
    projectDesc:
      "Building the official website for Ethiopian wushu federation",
    tags: ["React", "CSS", "Material Ui", "node"],
    // code: "https://github.com/Gtiko/Building-management-Application",
    demo: "https://ewuf.netlify.app/",
    image: ewf,
  },
  {
    id: 2,
    projectName: "Book Store",
    projectDesc:
      "This project is an e-commerce site for book where buying and selling of books based on availabilities",
    tags: ["Angular", "HTML", "Node", "CSS"],
    code: "https://github.com/Gtiko",
    demo: "http://book-store-frontend.s3-website.us-east-2.amazonaws.com/",
    image: four,
  },
  {
    id: 3,
    projectName: "Track and Split Expenses",
    projectDesc:
      "The application creates a shared space between a group of users to track their spending and display how much each user owes.",
    tags: ["Angular", "CSS", "node", "express"],
    code: "https://github.com/Gtiko/Expenses-Management-Application",
    demo: "http://track-and-split-expense-angular.s3-website.us-east-2.amazonaws.com",
    image: nine,
  },
  {
    id: 4,
    projectName: "Building Management",
    projectDesc:
      "This makes it easy Building owners to control and manage there building",
    tags: ["React", "CSS", "Material Ui"],
    code: "https://github.com/Gtiko/Building-management-Application",
    demo: "http://building-managment-react.s3-website.us-east-2.amazonaws.com/",
    image: two,
  },

  {
    id: 5,
    projectName: "Rock Paper scissor",
    projectDesc: "This project is a rock, paper, scissors game",
    tags: ["Angular", "CSS"],
    code: "https://github.com/Gtiko",
    demo: "https://zippy-crostata-12d41c.netlify.app/",
    image: five,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
